import { alertsApi } from "../../../api/apiClient";



function getFollowingAlerts(data)
{
    
  return alertsApi.post(`/alerts/following`,data)
}
function reGenerateAlert(data)
{
  return alertsApi.put(`/alerts/regeneration/`, data)

}


export const followingOnAlertsService = { 
    getFollowingAlerts,
    reGenerateAlert

};

